export enum EFacilityStatus {
    Pending = 1,
    Active = 2,
    Inactive = 3,
    NoNewMembers = 4,
    Potential = 5,
    PermanentlyClosed = 6
}
